<div class="flex">
<div class="px-1">
  <app-skeleton class="h-6 w-20" />
</div>
<div class="px-1">
  <app-skeleton class="h-6 w-20" />
</div>
</div>
